const NinjaWebConstants = {
    formIdAttribute: 'data-nj-form',
    errorAttribute: 'data-nj-errors',
};
const getNinjaComponentAttributes = (formId, hasErrors) => (Object.assign({}, (formId ? { [NinjaWebConstants.formIdAttribute]: formId, [NinjaWebConstants.errorAttribute]: hasErrors } : {})));

export { NinjaWebConstants, getNinjaComponentAttributes };
